import { Component,Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() hasInputText: boolean;
  @Input() inputTextVal: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
  public decline() {
    this.activeModal.dismiss();
    this.activeModal.close(false);
  }

  public accept() {
    if (this.hasInputText) {
      // Return object ONLY when input is used
      this.activeModal.close({
        confirmed: true,
        inputValue: this.inputTextVal
      });
    } else {
      // Keep old behavior (boolean)
      this.activeModal.close(true);
    }
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

}
